/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtFundReward = {
  pool: Address;
  funder: Address;
  mintReward: Address;
  rewardIndex: number;
  amount: bigint;
  transferFeeExcludedAmountIn: bigint;
  rewardDurationEnd: bigint;
  preRewardRate: bigint;
  postRewardRate: bigint;
};

export type EvtFundRewardArgs = {
  pool: Address;
  funder: Address;
  mintReward: Address;
  rewardIndex: number;
  amount: number | bigint;
  transferFeeExcludedAmountIn: number | bigint;
  rewardDurationEnd: number | bigint;
  preRewardRate: number | bigint;
  postRewardRate: number | bigint;
};

export function getEvtFundRewardEncoder(): FixedSizeEncoder<EvtFundRewardArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["funder", getAddressEncoder()],
    ["mintReward", getAddressEncoder()],
    ["rewardIndex", getU8Encoder()],
    ["amount", getU64Encoder()],
    ["transferFeeExcludedAmountIn", getU64Encoder()],
    ["rewardDurationEnd", getU64Encoder()],
    ["preRewardRate", getU128Encoder()],
    ["postRewardRate", getU128Encoder()],
  ]);
}

export function getEvtFundRewardDecoder(): FixedSizeDecoder<EvtFundReward> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["funder", getAddressDecoder()],
    ["mintReward", getAddressDecoder()],
    ["rewardIndex", getU8Decoder()],
    ["amount", getU64Decoder()],
    ["transferFeeExcludedAmountIn", getU64Decoder()],
    ["rewardDurationEnd", getU64Decoder()],
    ["preRewardRate", getU128Decoder()],
    ["postRewardRate", getU128Decoder()],
  ]);
}

export function getEvtFundRewardCodec(): FixedSizeCodec<
  EvtFundRewardArgs,
  EvtFundReward
> {
  return combineCodec(getEvtFundRewardEncoder(), getEvtFundRewardDecoder());
}
